import React from 'react'
import DataGrid, {
  ColumnChooser,
  FilterPanel,
  FilterRow,
  HeaderFilter,
  Export,
  Selection,
  SearchPanel,
  Editing,
  Column,
  Button,
  LoadPanel
} from "devextreme-react/data-grid";
import { useNavigate } from 'react-router-dom';

export const LVGridCarga = (props) => {
  let { dataSource, id, keyExpr, keyExpr2, keyExpr3, keyExpr4, keyExpr5, urlEdicion, AnchoBotonera, children, 
    onRowUpdated, onRowRemoving, onRowRemoved, 
    allowDeleting=true, allowAdding=false, filterRow=false, height, onRowInserted, width } = props;
  const navigate = useNavigate();

  const onClickEdit = (e) => {
    const Item = { ...e.row.data };
    let url = urlEdicion + "/" + Item[keyExpr]
    if (keyExpr2 && keyExpr2 !== "") {
      url = url + "/" + Item[keyExpr2]
    }
    if (keyExpr3 && keyExpr3 !== "") {
      url = url + "/" + Item[keyExpr3]
    }    
    if (keyExpr4 && keyExpr4 !== "") {
      url = url + "/" + Item[keyExpr4]
    }    
    if (keyExpr5 && keyExpr5 !== "") {
      url = url + "/" + Item[keyExpr5]
    }
    navigate(url)
  };

  const onClickClone = (e) => {
    
    const Item = { ...e.row.data };
  };

  return (
    <DataGrid
      dataSource={dataSource}
      showRowLines={true}
      showBorders={true}
      allowColumnResizing={true}
      id={id}
      keyExpr={keyExpr}
      rowAlternationEnabled={true}
      urlEdicion={urlEdicion}
      onRowInserted={onRowInserted}
      onRowUpdated={onRowUpdated}
      onRowRemoving={onRowRemoving}
      onRowRemoved={onRowRemoved}
      height={height}
      width={width}
    >
      
      <FilterRow visible={filterRow} />
      <Editing
      mode="cell"
      useIcons={true}
      allowAdding={allowAdding} 
      allowDeleting={allowDeleting}
      allowUpdating={true} 
      />
      
      {children}

    </DataGrid>
  );
}